import * as React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';

export default function AboutPage() {
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
            <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 600 }}>
        About
      </Typography>
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto',
          p: 3,
        })}
      >
        <Container maxWidth="md">
          <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
            <Typography component="h2" variant="h4" gutterBottom align="center">
              About RocketOffer
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              At <strong>RocketOffer.com</strong>, we’re revolutionizing the real estate investment process by making it faster, easier, and more profitable for homeowners, investors, and agents. Our all-in-one platform streamlines every step—from financing and renovations to staging and marketing—so you can buy, renovate, and sell homes with confidence.
            </Typography>
            <Typography variant="h6" gutterBottom>
              Our Mission
            </Typography>
            <Typography variant="body1" paragraph>
              We believe selling a home shouldn’t be complicated. Our mission is to provide a seamless, efficient process that eliminates common roadblocks, allowing sellers to maximize their profits while helping buyers and investors find high-potential properties with ease.
            </Typography>
            <Typography variant="h6" gutterBottom>
              How RocketOffer Works
            </Typography>
            <Typography variant="body1" paragraph>
              We offer a comprehensive suite of services to help you succeed in real estate:
            </Typography>
            <ul>
              <li><Typography variant="body1"><strong>Nontraditional Financing</strong> – Tailored funding solutions that close deals faster.</Typography></li>
              <li><Typography variant="body1"><strong>Professional Photos & Video</strong> – High-quality visuals that attract more buyers.</Typography></li>
              <li><Typography variant="body1"><strong>Cash Offers</strong> – Competitive offers designed to streamline the selling process.</Typography></li>
              <li><Typography variant="body1"><strong>Renovations</strong> – Expert-managed home improvements to boost value.</Typography></li>
              <li><Typography variant="body1"><strong>Home Staging</strong> – Transforming properties to create buyer appeal.</Typography></li>
              <li><Typography variant="body1"><strong>Premium Marketing</strong> – Custom marketing strategies to ensure top-dollar sales.</Typography></li>
            </ul>
            <Typography variant="h6" gutterBottom>
              Why Choose RocketOffer?
            </Typography>
            <Typography variant="body1" paragraph>
              🚀 <strong>Faster Closings</strong> – Our innovative financing and cash offer approach help you close deals in record time.
            </Typography>
            <Typography variant="body1" paragraph>
              📈 <strong>Maximized Profits</strong> – Strategic renovations and expert staging increase your home’s value.
            </Typography>
            <Typography variant="body1" paragraph>
              🔑 <strong>All-in-One Convenience</strong> – From listing to closing, we handle everything under one roof.
            </Typography>
            <Typography variant="h6" gutterBottom>
              Get Started Today
            </Typography>
            <Typography variant="body1" paragraph>
              Whether you’re selling, investing, or flipping homes, RocketOffer is here to help. <strong>Sign up now</strong> to explore our services and start achieving faster, more profitable real estate transactions!
            </Typography>
          </Paper>
        </Container>
      </Box>
    </Box>
  );
}
